/* eslint-disable @typescript-eslint/no-empty-interface */
const config = {
  domain: 'Academy',
  subdomain: 'Resources',
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Clicked {}

interface CourseClicked {
  topicId: string
  courseId: string
  courseTitle: string
}

interface CourseCompleted {
  topicId: string
  courseId: string
  courseTitle: string
}

interface CourseStarted {
  courseId: string
  courseTitle: string
}
interface RelatedCourseClicked {
  courseId: string
  courseTitle: string
}

interface RelatedResourceClicked {
  resourceId: string
  resourceName: string
  resourceType: string
}

interface CtaCourseClicked {
  courseId: string
  courseTitle: string
}

interface CtaResourceClicked {
  resourceId: string
  resourceName: string
  resourceType: string
}

interface CtaToolClicked {
  destinationUrl: string
}

export const trainings = {
  Clicked: { Clicked: (param: Clicked) => param, config },
  Start_Course_Clicked: {
    Start_Course_Clicked: (param: CourseClicked) => param,
    config,
  },
  Resume_Course_Clicked: {
    Resume_Course_Clicked: (param: CourseClicked) => param,
    config,
  },
  Review_Course_Clicked: {
    Review_Course_Clicked: (param: CourseClicked) => param,
    config,
  },
  Course_Completed: {
    Course_Completed: (param: CourseCompleted) => param,
    config,
  },
  Related_Course_Clicked: {
    Related_Course_Clicked: (param: RelatedCourseClicked) => param,
    config,
  },
  Related_Resource_Clicked: {
    Related_Resource_Clicked: (param: RelatedResourceClicked) => param,
    config,
  },
  Course_Started: {
    Course_Started: (param: CourseStarted) => param,
    config,
  },
  CTA_Course_Clicked: {
    CTA_Course_Clicked: (param: CtaCourseClicked) => param,
    config,
  },
  CTA_Resource_Clicked: {
    CTA_Resource_Clicked: (param: CtaResourceClicked) => param,
    config,
  },
  CTA_Tool_Clicked: {
    CTA_Tool_Clicked: (param: CtaToolClicked) => param,
    config,
  },
}
